<script lang="ts">
	import type { ProfileData, UserData } from "@hitit/api";
	//UI
	import EditProfileImage from "../components/profile/EditProfileImage.svelte";
	import EditBirth from "../components/profile/EditBirthDay.svelte";
	import EditName from "../components/profile/EditName.svelte";
	import EditEmail from "../components/profile/EditEmail.svelte";
	import EditPhone from "../components/profile/EditPhone.svelte";
	import HeaderActionLayout from "../../layouts/HeaderActionLayout.svelte";
	//Utils
	import { t, api, notifications } from "../../stores";

	import EditPassword from "../components/profile/EditPassword.svelte";
	import { onDestroy } from "svelte";
	import { popup } from "../store";

	//
	export let userId: string | undefined = undefined;

	let user: UserData;
	let profile: ProfileData;

	//functions

	async function loadData(userId?: string) {
		try {
			const [userResponse, profileResponse] = await Promise.all([
				$api.getUser(userId),
				$api.getProfile(userId),
			]);

			user = userResponse.data;
			profile = profileResponse.data;
		} catch (e) {
			const error = new Error($t("Get Profile or User Error"));
			notifications.defaultHandler(error);
		}
	}
	// Do
	$: loadData(userId);

	onDestroy(() => {
		$popup = undefined;
	});
</script>

<HeaderActionLayout title={$t("hub.profile.title")}>
	{#if user && profile}
		<div class="contents-container">
			<div class="profile-image-container">
				<EditProfileImage userId={user.id} />
			</div>
			<div class="card-container">
				<EditName user={user} bind:profile/>
				<EditEmail email={user.username} emailVerify={profile.emailVerified} />
				<EditPassword userId={user.id} />
				<EditPhone bind:profile={profile} />
				<EditBirth bind:profile={profile} />
			</div>
		</div>
	{/if}
</HeaderActionLayout>

<style lang="scss">
	@import "../../variables.scss";

	.contents-container {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		align-items: center;
		.card-container {
			display: flex;
			flex-direction: column;
			gap: 20px;
			padding: 20px 0px;
			width: 100%;
			border-radius: 5px;
			background-color: #ffffff;
			box-sizing: border-box;
		}
		.profile-image-container {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 250px;
			margin-top: 32px;
			margin-bottom: 20px;
		}
	}

	@include DesktopSize {
		.contents-container {
			.card-container {
				max-width: 900px;
				padding: 20px 0px;
				gap: 20px;
			}
			.profile-image-container {
				height: 350px;
				margin-top: 30px;
				margin-bottom: 50px;
			}
		}
	}
</style>
